// 授权书
import { i18n } from '@/common/utils/i18n'
// import AuthorizationType from '@/pages/shopDetail/config/AuthorizationType'
import { get } from 'lodash-es'

export default (state) => {
  let authorizationInfo = get(state, 'currentContractorDetail.contractInfo.authorizationInfo.sign', {})
  return {
    title: i18n.gettext('签字授权书'),
    content: [
      // {
      //   title: i18n.gettext('授权书类型'),
      //   content: AuthorizationType.val2text(authorizationInfo.authorizationType)
      // },
      // {
      //   title: i18n.gettext('授权人'),
      //   label: authorizationInfo.name
      // },
      // {
      //   title: i18n.gettext('被授权人'),
      //   label: authorizationInfo.authorizedName
      // },
      // {
      //   title: i18n.gettext('被授权人Curp号'),
      //   label: authorizationInfo.authorizedNum
      // },
      {
        title: i18n.gettext('被授权人证件照片'),
        content: i18n.gettext('查看'),
        isLink: true,
        arrow: true,
        pics: authorizationInfo.authorizedPics
      },
      {
        title: i18n.gettext('授权书照片'),
        content: i18n.gettext('查看'),
        isLink: true,
        arrow: true,
        pics: authorizationInfo.pics
      }
    ]
  }
}
